import { ONE_DAY } from "@walletconnect/time";

export const CRYPTO_CONTEXT = "crypto";

export const CRYPTO_CLIENT_SEED = "client_ed25519_seed";

export const CRYPTO_JWT_TTL = ONE_DAY;
